import axios, { AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import { requestTool } from "./rule";
// import * as Sentry from "@sentry/react";
import { loginStore } from "@/modules/login/store";
const instance = axios.create({
  timeout: 50000,
});

class Request {
  private baseUrl: string;
  private checkStatus: any;
  private noToast = false;

  constructor(baseURL: string, opt?: { noToast?: boolean }) {
    this.baseUrl = baseURL;
    this.noToast = opt?.noToast ?? false;

    this.checkStatus = (responseData: any) =>
      requestTool.checkStatus(responseData, { noToast: this.noToast });
  }

  interceptors<RequestData>(
    instance: AxiosInstance,
    url: string,
    data: RequestData,
    method: string,
  ) {
    // 请求拦截
    instance.interceptors.request.use(
      (config: any) => {
        config.headers = {
          ...config.headers,
          Authorization:
            !(location.pathname === "/guest" && loginStore.isGuest) && localStorage.token
              ? "Bearer " + localStorage.token
              : "",
        };
        return config;
      },
      (error: Promise<any>) => {
        return Promise.reject(error);
      },
    );
    // 响应拦截
    instance.interceptors.response.use(
      (response: any) => {
        if (process.env.REACT_APP_ENV === "production" && process.env.NODE_ENV !== "development") {
          if (response.data.code === 1) {
            // Sentry.captureException(
            //   new Error(
            //     `[api-request-error]:${200} ${response.config.url} msg:${response.data.msg}`,
            //   ),
            //   {
            //     level: "fatal",
            //     contexts: {
            //       message: {
            //         url: response.config.baseURL + response.config.url,
            //         method: response.config.method,
            //         status: response.status,
            //         statusText: response.statusText,
            //         requestData: response.config.data && JSON.stringify(response.config.data),
            //         responseData: JSON.stringify(response.data),
            //       },
            //     },
            //   },
            // );
          }
        }
        return response;
      },
      (error: any) => {
        if (process.env.REACT_APP_ENV === "production") {
          if ([500, 502, 503, 504, 404].includes(error.response.status)) {
            // Sentry.captureException(
            //   new Error(
            //     `[api-request-error]: ${error.response.status} ${error.response.config.url}`,
            //   ),
            //   {
            //     level: "fatal",
            //     contexts: {
            //       message: {
            //         url: error.response.config.baseURL + error.response.config.url,
            //         method: error.response.config.method,
            //         status: error.response.status,
            //         statusText: error.response.statusText,
            //         requestData:
            //           error.response.config.data && JSON.stringify(error.response.config.data),
            //         responseData: JSON.stringify(error.response.data),
            //       },
            //     },
            //   },
            // );
          }
        }

        return Promise.reject(error);
      },
    );
  }

  post<RequestData = any, ResponseData = any>(
    url: string,
    data?: RequestData,
    headers?: AxiosRequestHeaders,
    baseUrl?: string,
    onUploadProgress?: (data: any) => void,
    options?: Pick<AxiosRequestConfig, "timeout" | "timeoutErrorMessage">,
  ): Promise<Promise<ResponseData>> {
    this.interceptors(instance, url, data, "post");
    return new Promise<Promise<ResponseData>>((resolve, reject) => {
      return instance({
        method: "post",
        url,
        data,
        baseURL: baseUrl || this.baseUrl,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          ...headers,
        },
        onUploadProgress: onUploadProgress,
        ...options,
      })
        .then((response) => {
          resolve(this.checkStatus.call(requestTool, response.data));
        })
        .catch((err) => {
          if (err.response) {
            reject(this.checkStatus.call(requestTool, err.response));
          } else {
            reject(
              this.checkStatus.call(requestTool, {
                code: 502,
                msg: "",
                errCode: 502,
              }),
            );
          }
        });
    });
  }

  put<RequestData = any, ResponseData = any>(
    url: string,
    data?: RequestData,
    headers?: AxiosRequestHeaders,
    baseUrl?: string,
  ): Promise<Promise<ResponseData>> {
    this.interceptors(instance, url, data, "put");
    return new Promise<Promise<ResponseData>>((resolve, reject) => {
      return instance({
        method: "put",
        url,
        data,
        baseURL: baseUrl || this.baseUrl,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          ...headers,
        },
      })
        .then((response) => {
          resolve(this.checkStatus.call(requestTool, response.data));
        })
        .catch((err) => {
          if (err.response) {
            reject(this.checkStatus.call(requestTool, err.response));
          }
        });
    });
  }
  delete<RequestData = any, ResponseData = any>(
    url: string,
    data?: RequestData,
    headers?: AxiosRequestHeaders,
    baseUrl?: string,
  ): Promise<Promise<ResponseData>> {
    this.interceptors(instance, url, data, "put");
    return new Promise<Promise<ResponseData>>((resolve, reject) => {
      return instance({
        method: "delete",
        url,
        data,
        baseURL: baseUrl || this.baseUrl,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          ...headers,
        },
      })
        .then((response) => {
          resolve(this.checkStatus.call(requestTool, response.data));
        })
        .catch((err) => {
          if (err.response) {
            reject(this.checkStatus.call(requestTool, err.response));
          }
        });
    });
  }
  get<RequestData = any, ResponseData = any>(
    url: string,
    params?: RequestData,
    headers?: AxiosRequestHeaders,
    baseUrl?: string,
  ): Promise<Promise<ResponseData>> {
    this.interceptors(instance, url, params, "get");
    return new Promise<Promise<ResponseData>>((resolve, reject) => {
      return instance({
        method: "get",
        url,
        params,
        baseURL: baseUrl || this.baseUrl,
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          ...headers,
        },
      })
        .then((response) => {
          resolve(this.checkStatus.call(requestTool, response.data));
        })
        .catch((err) => {
          if (err.response) {
            reject(this.checkStatus.call(requestTool, err.response));
          }
        });
    });
  }
}

export default Request;
